import api from "api";
const qs = require("qs");

const PATH = "/Relatorio";

const GET_LIST_RELATORIO = async (params) => {
  try {
    const { data } = await api.get(`${PATH}/get-relatorio-questoes-erros`, {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
    });
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const GET_LIST_RELATORIO_USUARIO = async (params) => {
  try {
    const { data } = await api.get(`${PATH}/get-relatorio-usuario`, {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
    });
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
}

export { GET_LIST_RELATORIO, GET_LIST_RELATORIO_USUARIO };
